export default "__VITE_ASSET__DjmfNFEB__"